import React from 'react';
import UserDashboardUserSettings from 'components/UserDashboard/UserDashboardUserSettings/UserDashboardUserSettings';

const UserDashboardSettings = () => <UserDashboardUserSettings />;

export default UserDashboardSettings;
